import React from 'react';

const ConfirmPurgeModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onCancel} 
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onCancel} 
              disabled={loading}
            >
              {cancelText}
            </button>
            <button 
              type="button" 
              className="btn btn-danger" 
              onClick={onConfirm} 
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading-dots me-2" role="status" aria-hidden="true"></span>
                  {confirmText}
                </>
              ) : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPurgeModal; 